module.exports = __webpack_public_path__ + "static/4BHK-01-Living-Room-9b84ede8b644c552c8b52dfb8a106654.jpg";